import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { apiGet, apiPost, apiPut } from 'APIPackage/MainModule/common/apiTools';

import { ITestPurchaseMethod } from '../interfaces/ITestPurchaseMethod';

export async function fetchTestPurchaseMethods(): Promise<ITestPurchaseMethod[]> {
  return apiGet<ITestPurchaseMethod[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/test-purchase-methods`,
  );
}

export async function createTestPurchaseMethod(method: Omit<ITestPurchaseMethod, 'id'>): Promise<void> {
  return apiPost({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/test-purchase-methods`,
    body: method,
  });
}

export async function updateTestPurchaseMethod(method: ITestPurchaseMethod): Promise<void> {
  const { id, ...data } = method;

  return apiPut(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/test-purchase-methods/${id}`, data);
}
